import { useState } from "react"
import Navbar from "./Navbar"
import { Context, LoggedInUser } from "../../types/types"
import TemplateEditor from "../Templates/TemplateEditor"
import AppOfAppsTemplateEditor from "../Templates/AppOfAppsTemplateEditor"
import { permCheck } from "../../util/permChecker"

export interface TemplateSettingsPageProps {
    context: Context | undefined,
    user: LoggedInUser
}

function TemplateSettingsPage(props: TemplateSettingsPageProps) {

    const elements = ["App of Apps", "Values Template"]
    type elType = typeof elements[number]

    const filteredElements = permCheck(props.user, "ADMIN", props.context?.id ?? "") ? elements : [elements[1]]

    const [selected, setSelected] = useState<elType>(filteredElements[0])


    const renderSetting = () => {
        switch(selected) {  
            case "App of Apps":
                return (
                    <AppOfAppsTemplateEditor/>
                )
            case "Values Template":
                return (
                    <TemplateEditor
                        context={props.context}
                    />
                )
        }
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
            <Navbar
                elements={filteredElements}
                selectedEl={selected}
                setSelected={setSelected}
            />
            {renderSetting()}
        </div>
    )
}

export default TemplateSettingsPage